import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { styles } from "../styles";
import { navLinks } from "../constants";
import { menu, close } from "../assets";
import logo from "../assets/logo.png";
import resume from "../assets/SACHIN_SHAKYA.pdf";

const Navbar = () => {
  const [active, setActive] = useState("");
  const [toggle, setToggle] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      if (scrollTop > 100) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`${
        styles.paddingX
      } w-full flex items-center py-5 md:py-2 fixed top-0 z-20 ${
        scrolled ? "bg-transparent" : "bg-transparent"
      }`}
    >
      <div className="w-full flex justify-between items-center max-w-7xl mx-auto">
        <Link
          to="/"
          className="flex items-center gap-2"
          onClick={() => {
            setActive("");
            window.scrollTo(0, 0);
          }}
        >
          <p className="text-white text-[25px] font-bold cursor-pointer flex ">
            <img
              src={logo}
              alt="logo"
              className="w-20 md:h-20 rounded-full object-contain"
            />
          </p>
        </Link>

        <ul className="list-none hidden md:flex flex-row gap-10 bg-primary py-2 px-6 rounded-xl">
          <li className="font-poppins font-medium cursor-pointer text-[16px] text-secondary hover:text-white">
            <a href={resume} download="sachin_shakya">
              Download CV
            </a>
          </li>
          <li className="font-poppins font-medium cursor-pointer text-[16px] text-secondary hover:text-white">
            <a href="tel:7500986056">Hire Me</a>
          </li>

          {navLinks.map((nav) => (
            <li
              key={nav.id}
              className={`${
                active === nav.title ? "text-white" : "text-secondary"
              } hover:text-white text-[18px] font-medium cursor-pointer`}
              onClick={() => setActive(nav.title)}
            >
              <a href={`#${nav.id}`}>{nav.title}</a>
            </li>
          ))}
        </ul>

        <div className="md:hidden flex flex-1 justify-end items-center">
          <img
            src={toggle ? close : menu}
            alt="menu"
            className="w-[28px] h-[28px] object-contain"
            onClick={() => setToggle(!toggle)}
          />

          <div
            className={`${
              !toggle ? "hidden" : "flex"
            } p-6 black-gradient absolute top-20 right-0 mx-4 my-2 min-w-[140px] z-10 rounded-xl`}
          >
            <ul className="list-none flex justify-end items-start flex-1 flex-col gap-4 ">
              <li className="font-poppins font-medium cursor-pointer text-[16px] text-secondary hover:text-white">
                <a href={resume} download="sachin_shakya">
                  Download CV
                </a>
              </li>
              <li className="font-poppins font-medium cursor-pointer text-[16px] text-secondary hover:text-white">
                <a href="tel:7500986056">Hire Me</a>
              </li>
              {navLinks.map((nav) => (
                <li
                  key={nav.id}
                  className={`font-poppins font-medium cursor-pointer text-[16px] ${
                    active === nav.title ? "text-white" : "text-secondary"
                  }`}
                  onClick={() => {
                    setToggle(!toggle);
                    setActive(nav.title);
                  }}
                >
                  <a href={`#${nav.id}`}>{nav.title}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
